import React from 'react';

/**
 * Sticky toolbar shell: title/actions row + filter row.
 * marginClassName controls outer negative margins (template vs dashboard).
 */
export default function MealSlotEditorToolbar({
  marginClassName = '-mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8',
  topRow,
  filterRow,
}) {
  return (
    <div
      className={`sticky top-0 z-10 bg-gray-50 ${marginClassName} py-3 mb-6 border-b border-gray-200 shadow-sm`}
    >
      <div className="bg-white rounded-xl shadow-sm p-3">
        <div className="flex items-center gap-3 flex-nowrap mb-2 pb-2 border-b border-gray-200 overflow-x-auto min-w-0">
          {topRow}
        </div>
        {filterRow != null && (
          <div className="flex items-center gap-3 flex-wrap">{filterRow}</div>
        )}
      </div>
    </div>
  );
}
